import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full h-[320px] md:h-[420px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20background%20with%20soft%20amber%20and%20cream%20gradients%2C%20flowing%20organic%20shapes%2C%20dreamy%20atmosphere%2C%20subtle%20texture%2C%20modern%20minimalist%20digital%20art%2C%20warm%20golden%20light%20diffused%20across%20the%20composition%2C%20elegant%20and%20inviting%20mood&width=1920&height=800&seq=cta-bg-2026-x2&orientation=landscape"
          alt="韩漫画网 更多精彩内容"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/50"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 lg:gap-12">
            <div className="max-w-lg">
              <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4">
                每日更新
                <br />
                精彩不停
              </h2>
              <p className="text-background-50/70 text-sm md:text-base leading-relaxed max-w-md">
                韩漫画网持续更新海量韩国漫画资源，下拉式完整版免费阅读，
                无删减内容给您最纯粹的阅读享受。
              </p>
            </div>
            <div className="flex items-center gap-3">
              <Link
                to="/category"
                className="px-8 py-3 bg-background-50 hover:bg-background-100 text-foreground-950 font-medium rounded-full text-sm md:text-base transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                立即探索
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 border border-background-50/40 hover:border-background-50/80 text-background-50 font-medium rounded-full text-sm md:text-base transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}